import { fcaFastApi, fcaGateWay } from "../../services/authorizationService";
import * as serviceEndpoints from "../../config/serviceEndPoints";

export const getSoftCostsData = params =>
    fcaFastApi.get(`${params.recommendation_id ? serviceEndpoints.leaseSoftCost.recommendationSoftCosts : serviceEndpoints.leaseSoftCost.softCosts}`, {
        params
    });
export const saveSoftCostsData = data =>
    fcaFastApi.post(
        `${data.lease_id ? serviceEndpoints.leaseSoftCost.saveRecommendationSoftCosts : serviceEndpoints.leaseSoftCost.saveSoftCosts}`,
        data
    );
export const saveDynamicSoftCostField = data => fcaFastApi.post(`${serviceEndpoints.leaseSoftCost.saveDynamicSoftCostField}`, data);
export const updateDynamicSoftCostField = data => fcaFastApi.patch(`${serviceEndpoints.leaseSoftCost.updateDynamicSoftCostField}${data?.id}`, data);
export const deleteDynamicSoftCostField = (id, params) =>
    fcaFastApi.delete(`${serviceEndpoints.leaseSoftCost.updateDynamicSoftCostField}${id}`, { params });
export const exportExcel = params => fcaGateWay.get(`${serviceEndpoints.leaseSoftCost.exportExcel}`, { method: "GET", responseType: "blob", params });
export const resetSoftCost = params => fcaFastApi.patch(`${serviceEndpoints.leaseSoftCost.resetSoftCost}`, params);
